import type { BookmarkType } from "@circle-react/types/Bookmarks";
import { Tabs } from "@circleco/compass/components/Tabs";
import { useState } from "react";

import { t } from "@/i18n-js/instance";

import { BOOKMARK_TAB_VALUES } from "./constants";
import { BookmarksList } from "./List";

export const Bookmarks = () => {
  const [activeTab, setActiveTab] = useState<BookmarkType>("post");

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="border-primary flex flex-col items-start px-6 pb-0 lg:border-b lg:pb-5">
        <Tabs.Root
          tabs={BOOKMARK_TAB_VALUES.map(value => ({
            value,
            label: t(["bookmarks.tabs", value]),
          }))}
          selectedValue={activeTab}
          onValueChange={(value: string) => setActiveTab(value as BookmarkType)}
          size="md"
        />
      </div>
      <BookmarksList activeTab={activeTab} />
    </div>
  );
};
